import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme, Typography } from '@material-ui/core'
import clsx from 'clsx'
import React, { FC, Fragment } from 'react'

import { SupportedOptionsObject } from 'bpm/pages/ProductsPage/ProductDetailsPage/components/ListingDetailsPage'

import OptionGroups from '../../../OptionGroups'
import { Propertyname } from '../../../Propertyname'
import { NonMSPropertyType } from '../nonMSTypes'

interface NonMSPropertySectionProps {
    property: NonMSPropertyType
    selectedOptions: SupportedOptionsObject
}

const useStyles = makeStyles((theme: Theme) => ({
    propContent: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        wordBreak: 'break-word',
    },
    content: {
        marginTop: theme.spacing(1.5),
    },
    subPropertyName: {
        fontSize: pxToRem(13),
    },
}))

const NonMSPropertySectionViewMode: FC<NonMSPropertySectionProps> = ({
    property,
    selectedOptions,
}) => {
    const classes = useStyles()
    const { propertyName, subProperties } = property

    return (
        <GridItem xs={12}>
            <GridContainer>
                <Propertyname propertyName={propertyName} />
                {subProperties?.map((subProperty) => {
                    const { subPropertyName, optionGroups } = subProperty
                    return (
                        <GridItem
                            className={clsx(
                                classes.content,
                                classes.propContent
                            )}
                            xs={12}
                            key={`${propertyName}${subPropertyName}`}
                        >
                            <GridContainer>
                                <GridItem md={3}>
                                    <Typography
                                        component="span"
                                        className={classes.subPropertyName}
                                    >
                                        {subPropertyName}
                                    </Typography>
                                </GridItem>
                                <Fragment>
                                    {optionGroups?.map(
                                        ({
                                            groupId,
                                            prefix,
                                            postfix,
                                            options,
                                        }) => {
                                            return (
                                                <OptionGroups
                                                    key={groupId}
                                                    groupId={groupId}
                                                    prefix={prefix ?? ''}
                                                    options={options ?? []}
                                                    propertyName={propertyName}
                                                    subPropertyName={
                                                        subPropertyName ?? ''
                                                    }
                                                    postfix={postfix ?? ''}
                                                    selectedData={
                                                        selectedOptions
                                                    }
                                                    mode="nonMSviewOnly"
                                                />
                                            )
                                        }
                                    )}
                                </Fragment>
                            </GridContainer>
                        </GridItem>
                    )
                })}
            </GridContainer>
        </GridItem>
    )
}

export default NonMSPropertySectionViewMode
